/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _toConsumableArray } from '../_chunks/dep-8c39d78a.mjs';
import { _ as _slicedToArray } from '../_chunks/dep-dcf624da.mjs';
import { _ as _defineProperty } from '../_chunks/dep-0b4c3c44.mjs';
import { isVNode, defineComponent, watchEffect, toRefs, ref, computed, reactive, provide, watch, onMounted, createVNode } from 'vue';
import log from '../_common/js/log/log.mjs';
import props from './head-menu-props.mjs';
import { Tabs, TabPanel } from '../tabs/index.mjs';
import { renderContent, renderTNodeJSX } from '../utils/render-tnode.mjs';
import VMenu from './v-menu.mjs';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import useVModel from '../hooks/useVModel.mjs';
import useDefaultValue from '../hooks/useDefaultValue.mjs';
import '../_chunks/dep-556a2f2c.mjs';
import '../tabs/tabs.mjs';
import '../tabs/tab-panel.mjs';
import '../tabs/tab-panel-props.mjs';
import '../hooks/useDestroyOnClose.mjs';
import '../hooks/tnode.mjs';
import '../_chunks/dep-40522c7c.mjs';
import '../_chunks/dep-a48de419.mjs';
import '../_chunks/dep-83862ee1.mjs';
import '../_chunks/dep-f6b25712.mjs';
import '../_chunks/dep-3ca5fb38.mjs';
import '../_chunks/dep-7071345f.mjs';
import '../_chunks/dep-59545a4d.mjs';
import '../_chunks/dep-c27b1c14.mjs';
import '../_chunks/dep-7d96367f.mjs';
import '../_chunks/dep-4889eb51.mjs';
import '../_chunks/dep-0b4185fe.mjs';
import '../_chunks/dep-d2403b2f.mjs';
import '../_chunks/dep-7922050a.mjs';
import '../_chunks/dep-caad2e91.mjs';
import '../_chunks/dep-3d4aad09.mjs';
import '../_chunks/dep-469bf54b.mjs';
import '../_chunks/dep-8e451077.mjs';
import '../_chunks/dep-a82b01df.mjs';
import '../_chunks/dep-192e10f1.mjs';
import '../_chunks/dep-977c5cdd.mjs';
import '../_chunks/dep-755716aa.mjs';
import '../_chunks/dep-82798823.mjs';
import '../_chunks/dep-52cbb58a.mjs';
import '../_chunks/dep-db11154e.mjs';
import '../_chunks/dep-baa4f9dc.mjs';
import '../tabs/tab-nav.mjs';
import '../_chunks/dep-241fdd8c.mjs';
import '../_chunks/dep-050b3eb2.mjs';
import 'tdesign-icons-vue-next';
import '../tabs/props.mjs';
import '../_common/js/tabs/base.mjs';
import '../tabs/tab-nav-item.mjs';
import '../hooks/useRipple.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../_chunks/dep-bfb23a5e.mjs';
import '../_chunks/dep-2a7dc5c7.mjs';
import '../_chunks/dep-9311bf66.mjs';
import '../_chunks/dep-169ea640.mjs';
import '../_chunks/dep-827c4600.mjs';
import '../_chunks/dep-0820e0e2.mjs';
import '../_chunks/dep-8e38f523.mjs';
import '../_chunks/dep-8ef9fb8e.mjs';
import '../_chunks/dep-e769aafd.mjs';
import '../_chunks/dep-400798c5.mjs';
import '../_chunks/dep-361522ee.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../config-provider/useConfig.mjs';
import '../config-provider/type.mjs';
import '../utils/set-style.mjs';
import '../hooks/useGlobalIcon.mjs';
import '../tabs/tab-nav-bar.mjs';
import '../utils/helper.mjs';
import '../_chunks/dep-e68fd68c.mjs';
import '../hooks/useListener.mjs';
import '../hooks/useDragSort.mjs';
import '../utils/withInstall.mjs';
import './style/css.mjs';
import '../tabs/type.mjs';
import '../_chunks/dep-2684fd15.mjs';
import '../_chunks/dep-84a9ab7d.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _isSlot(s) {
  return typeof s === 'function' || Object.prototype.toString.call(s) === '[object Object]' && !isVNode(s);
}

var _HeadMenu = defineComponent({
  name: "THeadMenu",
  props: _objectSpread({}, props),
  setup: function setup(props2, ctx) {
    var classPrefix = usePrefixClass();
    watchEffect(function () {
      if (ctx.slots.options) {
        log.warnOnce("TMenu", "`options` slot is going to be deprecated, please use `operations` for slot instead.");
      }
    });

    var _toRefs = toRefs(props2),
        value = _toRefs.value,
        modelValue = _toRefs.modelValue,
        expanded = _toRefs.expanded;

    var _useVModel = useVModel(value, modelValue, props2.defaultValue, props2.onChange),
        _useVModel2 = _slicedToArray(_useVModel, 2),
        activeValue = _useVModel2[0],
        setActiveValue = _useVModel2[1];

    var _useDefaultValue = useDefaultValue(expanded, props2.defaultExpanded, props2.onExpand, "expanded"),
        _useDefaultValue2 = _slicedToArray(_useDefaultValue, 2),
        expandValues = _useDefaultValue2[0],
        setExpanded = _useDefaultValue2[1];

    var activeValues = ref([]);
    var theme = computed(function () {
      return props2.theme;
    });
    var menuClass = computed(function () {
      return ["".concat(classPrefix.value, "-menu"), "".concat(classPrefix.value, "-head-menu"), "".concat(classPrefix.value, "-menu--").concat(props2.theme)];
    });
    var mode = ref(props2.expandType);
    var submenu = reactive([]);
    var vMenu = new VMenu({
      isMutex: true,
      expandValues: expandValues.value
    });
    provide("TdMenu", {
      mode: mode,
      theme: theme,
      vMenu: vMenu,
      isHead: true,
      expandValues: expandValues,
      activeValue: activeValue,
      activeValues: activeValues,
      select: function select(value2) {
        setActiveValue(value2);
      },
      open: function open(value2, type) {
        var expanded2 = _toConsumableArray(expandValues.value);

        var index = expanded2.indexOf(value2);

        if (mode.value === "popup") {
          if (type === "add") {
            if (index === -1) {
              expanded2.push(value2);
            }
          } else if (type === "remove") {
            expanded2.splice(index, 1);
          }
        } else {
          expanded2.splice(0, 1);

          if (index === -1) {
            expanded2.push(value2);
          }
        }

        setExpanded(expanded2);
      }
    });

    var handleTabChange = function handleTabChange(value2) {
      setActiveValue(value2);
    };

    var handleSubmenuExpand = function handleSubmenuExpand(value2) {
      var ans = vMenu.getChild(value2);
      submenu.length = 0;
      submenu.push.apply(submenu, _toConsumableArray(ans));
    };

    watch(expandValues, function (value2) {
      if (mode.value === "normal") {
        handleSubmenuExpand(value2[0]);
      }
    });

    var updateActiveValues = function updateActiveValues(value2) {
      activeValues.value = vMenu.select(value2);
    };

    watch(activeValue, updateActiveValues);
    watch(function () {
      return props2.expandType;
    }, function (value2) {
      mode.value = value2;
    });
    onMounted(function () {
      var _expandValues$value;

      activeValues.value = vMenu.select(activeValue.value);

      if (((_expandValues$value = expandValues.value) === null || _expandValues$value === void 0 ? void 0 : _expandValues$value.length) > 0) {
        handleSubmenuExpand(expandValues.value[0]);
      }
    });
    return {
      classPrefix: classPrefix,
      mode: mode,
      menuClass: menuClass,
      expandValues: expandValues,
      activeValue: activeValue,
      activeValues: activeValues,
      submenu: submenu,
      handleTabChange: handleTabChange
    };
  },
  methods: {
    renderNormalSubmenu: function renderNormalSubmenu() {
      var _slot;

      if (this.submenu.length === 0) return null;
      return createVNode("ul", {
        "class": ["".concat(this.classPrefix, "-head-menu__submenu"), "".concat(this.classPrefix, "-submenu")]
      }, [createVNode(Tabs, {
        "value": this.activeValue,
        "onChange": this.handleTabChange
      }, _isSlot(_slot = this.submenu.map(function (item) {
        var _item$vnode$;

        return createVNode(TabPanel, {
          "value": item.value,
          "label": (_item$vnode$ = item.vnode()[0]) === null || _item$vnode$ === void 0 ? void 0 : _item$vnode$.children
        }, null);
      })) ? _slot : {
        "default": function _default() {
          return [_slot];
        }
      })]);
    }
  },
  render: function render() {
    var classPrefix = this.classPrefix;
    var operations = renderContent(this, "operations", "options");
    var logo = renderTNodeJSX(this, "logo");
    return createVNode("div", {
      "class": this.menuClass
    }, [createVNode("div", {
      "class": "".concat(classPrefix, "-head-menu__inner")
    }, [logo && createVNode("div", {
      "class": "".concat(classPrefix, "-menu__logo")
    }, [logo]), createVNode("ul", {
      "class": "".concat(classPrefix, "-menu")
    }, [renderContent(this, "default", "content")]), operations && createVNode("div", {
      "class": "".concat(classPrefix, "-menu__operations")
    }, [operations])]), this.mode === "normal" && this.renderNormalSubmenu()]);
  }
});

export { _HeadMenu as default };
//# sourceMappingURL=head-menu.mjs.map
